import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ChatMessage = ({ message, isUser, timestamp, avatar, avatarAlt }) => {
  return (
    <div className={`flex gap-3 ${isUser ? 'flex-row-reverse' : 'flex-row'} mb-4 animate-fade-in`}>
      <div className="flex-shrink-0">
        {isUser ? (
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-accent to-primary flex items-center justify-center">
            <Icon name="User" size={20} color="#FFFFFF" />
          </div>
        ) : (
          <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-accent/20">
            <Image 
              src={avatar} 
              alt={avatarAlt}
              className="w-full h-full object-cover"
            />
          </div>
        )}
      </div>
      
      <div className={`flex flex-col max-w-[75%] ${isUser ? 'items-end' : 'items-start'}`}>
        <div className={`rounded-2xl px-4 py-3 ${
          isUser 
            ? 'bg-gradient-to-br from-accent to-primary text-accent-foreground' 
            : 'bg-card border border-border text-foreground'
        }`}>
          <p className="text-sm leading-relaxed whitespace-pre-wrap">{message}</p>
        </div>
        <span className="text-xs text-muted-foreground mt-1 px-2">{timestamp}</span>
      </div>
    </div>
  );
};

export default ChatMessage;